import styled from 'styled-components';

export const Description = styled.div`
  color: #272a5e;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
`;

export const SelectContainer = styled.div`
  display: flex;
  gap: 16px;
  margin: 32px 0;

  > div {
    flex: 1;
  }

  @media ${({ theme }) => theme.queries.mobile} {
    flex-direction: column;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;

  & > button {
    margin: 12px 12px 0 0;
  }
`;
